import * as React from 'react';
import { useTranslation } from 'react-i18next';

export const MaintenancePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div>
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n      body {\n        font-family: 'Roboto', sans-serif;\n        height: 100%;\n        width: 100%;\n        color: #333333;\n        margin: 0 auto;\n        display: flex;\n        align-items: center;\n      }\n      .center {\n        text-align: center;\n        display: flex;\n        flex-direction: column;\n        margin: auto;\n        padding: 50px;\n      }\n      .logo {\n        display: flex;\n        justify-content: center;\n        flex: 0 0 auto;\n      }\n      .logo-circle {\n        width: 96px;\n        height: 10px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n      .logo-icon {\n        height: 60px;\n        width: 60px;\n      }\n      .logo-circle svg {\n        margin-bottom: 8px;\n      }\n      .inline {\n        justify-content: center;\n        align-items: center;\n        padding-bottom: 30px;\n      }\n      .inline > div:not(:last-child) {\n        font: normal normal bold 48px/63px Roboto;\n      }\n      .inline > div:first-child {\n        margin-bottom: 24px;\n      }\n      .inline div:last-child  {\n        padding-top: 6px;\n        font: normal normal normal 20px/22px Roboto;\n      }\n    ",
          }}
        />
        <div className="center">
          <div className="inline">
            <div className="logo">
              <div>
                <img src="https://www.amnhealthcare.com/siteassets/logo-amn.png" alt={t('global.amnHealthcare')} />
              </div>
            </div>
            <div>{t('global.maintenance.site')}</div>
            <div>{t('global.maintenance.unavailable')}</div>
            <div>
              <div>
                <div>{t('global.maintenance.underMaintenance')}</div>
                <div>{t('global.maintenance.helpMaintenance')}</div>
              </div>
            </div>
          </div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="619.011" height="381.129" viewBox="0 0 619.011 381.129">
              <g id="Group_4" data-name="Group 4" transform="translate(0.52 0.5)">
                <path
                  id="Path_1"
                  data-name="Path 1"
                  d="M629.081,331.907a126.639,126.639,0,0,1-3.71,30.558q-1.249,5.053-2.9,9.9a116.868,116.868,0,0,1-4.68,11.711q-1.338,2.9-2.828,5.677a76.375,76.375,0,0,1-6.386,30.69A79.119,79.119,0,0,1,570.178,460a80.768,80.768,0,0,1-34.279,7.87H128.4a102.672,102.672,0,0,1-51.641-13.8l-.241-.136q-3.353-1.962-6.538-4.156a102.532,102.532,0,0,1-13.417-11.061A99.837,99.837,0,0,1,41.812,420.44a97.52,97.52,0,0,1-15-52.066,122.784,122.784,0,0,1-15.741-60.8c0-28.334,9.214-54.18,24.351-73.746a103.676,103.676,0,0,1,10.342-11.507,96.241,96.241,0,0,1,11.827-9.681,92.026,92.026,0,0,1,10.494-6.3c1.516-.771,3.038-1.5,4.586-2.177,1.359-.6,2.734-1.165,4.124-1.695q2.5-.95,5.069-1.747t5.063-1.4q3.673-.9,7.472-1.459c2.1-.31,4.2-.525,6.3-.687,1.669-.126,3.353-.194,5.048-.215h.918c1.868,0,3.725.073,5.567.2.194-.388.4-.782.6-1.165.735-1.4,1.5-2.8,2.261-4.161a.129.129,0,0,1,0-.037c.131-.241.262-.477.4-.708.619-1.118,1.265-2.225,1.926-3.321.3-.525.6-1.018.913-1.511a4.015,4.015,0,0,1,.215-.357q.472-.787.96-1.574,2.429-3.883,5.053-7.629l.446-.64c.273-.388.525-.766.829-1.154.724-1.013,1.469-2.031,2.219-3.028.525-.714,1.049-1.422,1.616-2.1q2.046-2.623,4.2-5.247t4.47-5.179c.21-.236.42-.467.64-.7l2.24-2.445h0c.11-.115.2-.22.31-.325h0c.268-.289.525-.577.813-.855,1.2-1.275,2.435-2.524,3.673-3.767a200.012,200.012,0,0,1,20.1-17.509c.278-.22.561-.43.84-.64,1.333-1,2.686-1.994,4.04-2.97a212.659,212.659,0,0,1,23.3-14.534c.556-.32,1.123-.619,1.695-.913a222.475,222.475,0,0,1,22.294-10.263c4.15-1.642,8.4-3.185,12.666-4.6,2.844-.934,5.7-1.821,8.589-2.655q6.779-1.952,13.653-3.5a243.116,243.116,0,0,1,41.052-5.593q6.3-.32,12.734-.331a243.988,243.988,0,0,1,61.39,7.766,2.214,2.214,0,0,0,1.9.992h1.763c.766.21,1.527.42,2.293.64q6.417,1.847,12.65,4.035l1.049.378a225.845,225.845,0,0,1,29.861,13.117,215.484,215.484,0,0,1,25,15.447q1.842,1.322,3.631,2.665,2.172-1.39,4.418-2.665a86.9,86.9,0,0,1,18.3-7.8,83.48,83.48,0,0,1,41.052-1.606c17.446,3.7,33.24,12.881,46,25.941a107.327,107.327,0,0,1,13.794,17.514c.289.451.577.908.855,1.369a115.434,115.434,0,0,1,8.783,17.509c.089.226.178.436.257.656a121.253,121.253,0,0,1,5.4,17.5c.063.3.136.6.2.908a126,126,0,0,1,2.581,17.509,3.394,3.394,0,0,0,.042.645q.331,4.57.336,9.235c0,2.781-.094,5.541-.268,8.28,0,.3-.042.609-.068.918-.047.792-.115,1.574-.184,2.372a99.584,99.584,0,0,1,11.218,10.583q2.293,2.5,4.439,5.195a110.513,110.513,0,0,1,11.438,17.509A122.875,122.875,0,0,1,629.081,331.907Z"
                  transform="translate(-11.09 -87.76)"
                  fill="#52429a"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_2"
                  data-name="Path 2"
                  d="M629.074,775.857c0,3.584-12.346,6.942-33.89,9.828h-407.5a102.673,102.673,0,0,1-51.641-13.8l-.241-.136c6.191-2.256,17.368-4.36,32.579-6.26h0l.682-.084c6.821-.834,14.445-1.627,22.777-2.377a5.188,5.188,0,0,0,.635-.058h0q9.917-.882,21.1-1.653c.236,0,.467-.042.7-.052q4.313-.31,8.8-.588h0l1.154-.073c21.8-1.354,46.583-2.435,73.458-3.148h.031q5.646-.157,11.412-.278,6.412-.152,12.981-.268c3.342-.073,6.727-.126,10.121-.178h.079c15.316-.231,31.141-.346,47.323-.346,40.014,0,77.834.729,111.346,2.041h.094c5.153.2,10.211.42,15.143.645l4.2.2q8.348.4,16.266.855h0C588.756,763.652,629.074,769.387,629.074,775.857Z"
                  transform="translate(-70.374 -405.556)"
                  fill="#6c63ff"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <g id="Group_1" data-name="Group 1" transform="translate(326.012 207.249)" opacity="0.2">
                  <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M681.213,744.982a9.951,9.951,0,0,1-.194,1.684q-5.478-.871-11.019-1.574v-.451a8.858,8.858,0,0,1,1.312-4.449,4.881,4.881,0,0,1,8.883.273,8.851,8.851,0,0,1,1.018,4.518Z"
                    transform="translate(-650.293 -603.815)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_1"
                    data-name="Ellipse 1"
                    cx="7.351"
                    cy="5.614"
                    rx="7.351"
                    ry="5.614"
                    transform="translate(19.768 139.195) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="7.351"
                    cy="5.614"
                    rx="7.351"
                    ry="5.614"
                    transform="translate(20.054 130.212) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="7.351"
                    cy="5.614"
                    rx="7.351"
                    ry="5.614"
                    transform="translate(20.335 121.229) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_4"
                    data-name="Ellipse 4"
                    cx="7.351"
                    cy="5.614"
                    rx="7.351"
                    ry="5.614"
                    transform="translate(20.616 112.246) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M639.8,525.669a26.058,26.058,0,0,1-1.994-3.148l14.828-1.957-15.961-.383a26.959,26.959,0,0,1,.163-21.324l21.051,11.779L638.606,495.5a26.906,26.906,0,1,1,43.466,31.482,26.652,26.652,0,0,1,2.912,5l-19.461,9.34,20.636-6.207a26.938,26.938,0,0,1-5.153,25.138,26.907,26.907,0,1,1-42.27-1.333,26.906,26.906,0,0,1,1.049-33.255Z"
                    transform="translate(-632.44 -482.747)"
                    fill="#52429a"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M687.3,598.735a26.76,26.76,0,0,1-6.3,16.444,26.907,26.907,0,1,1-42.27-1.333C635.289,609.16,687.4,595.718,687.3,598.735Z"
                    transform="translate(-632.44 -537.669)"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                    opacity="0.1"
                  />
                </g>
                <g id="Group_2" data-name="Group 2" transform="translate(246.258 207.249)" opacity="0.2">
                  <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M529.213,744.982a9.976,9.976,0,0,1-.194,1.684q-5.478-.871-11.019-1.574v-.451a8.858,8.858,0,0,1,1.312-4.449,4.881,4.881,0,0,1,8.883.273,8.851,8.851,0,0,1,1.018,4.518Z"
                    transform="translate(-498.293 -603.815)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_5"
                    data-name="Ellipse 5"
                    cx="7.351"
                    cy="5.614"
                    rx="7.351"
                    ry="5.614"
                    transform="translate(19.762 139.197) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_6"
                    data-name="Ellipse 6"
                    cx="7.351"
                    cy="5.614"
                    rx="7.351"
                    ry="5.614"
                    transform="translate(20.048 130.214) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_7"
                    data-name="Ellipse 7"
                    cx="7.351"
                    cy="5.614"
                    rx="7.351"
                    ry="5.614"
                    transform="translate(20.329 121.231) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_8"
                    data-name="Ellipse 8"
                    cx="7.351"
                    cy="5.614"
                    rx="7.351"
                    ry="5.614"
                    transform="translate(20.61 112.248) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M487.8,525.669a26.059,26.059,0,0,1-1.994-3.148l14.828-1.957-15.961-.383a26.959,26.959,0,0,1,.163-21.324l21.051,11.779L486.605,495.5a26.907,26.907,0,1,1,43.466,31.482,26.657,26.657,0,0,1,2.912,5l-19.461,9.34,20.636-6.207a26.938,26.938,0,0,1-5.153,25.138,26.907,26.907,0,1,1-42.27-1.333,26.907,26.907,0,0,1,1.049-33.255Z"
                    transform="translate(-480.44 -482.747)"
                    fill="#52429a"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M535.3,598.735a26.759,26.759,0,0,1-6.3,16.444,26.907,26.907,0,1,1-42.27-1.333C483.289,609.16,535.4,595.718,535.3,598.735Z"
                    transform="translate(-480.44 -537.669)"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                    opacity="0.1"
                  />
                </g>
                <g id="Group_3" data-name="Group 3" transform="translate(435.541 82.485)" opacity="0.2">
                  <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M934.978,749.589a19.582,19.582,0,0,1-.383,3.19q-10.547-1.684-21.245-3.012V748.9a17.052,17.052,0,0,1,2.529-8.568c2.1-3.29,5.247-5.352,8.726-5.247s6.506,2.366,8.4,5.772a17.068,17.068,0,0,1,1.978,8.731Z"
                    transform="translate(-875.486 -477.919)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_9"
                    data-name="Ellipse 9"
                    cx="14.156"
                    cy="10.814"
                    rx="14.156"
                    ry="10.814"
                    transform="translate(38.001 267.864) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_10"
                    data-name="Ellipse 10"
                    cx="14.156"
                    cy="10.814"
                    rx="14.156"
                    ry="10.814"
                    transform="translate(38.546 250.57) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_11"
                    data-name="Ellipse 11"
                    cx="14.156"
                    cy="10.814"
                    rx="14.156"
                    ry="10.814"
                    transform="translate(39.097 233.275) rotate(-88.19)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <ellipse
                    id="Ellipse_12"
                    data-name="Ellipse 12"
                    cx="14.156"
                    cy="10.814"
                    rx="14.156"
                    ry="10.814"
                    transform="translate(39.037 215.233) rotate(-88.282)"
                    fill="#3f3d56"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M855.318,327.5a52.09,52.09,0,0,1-3.836-6.05l28.544-3.767-30.721-.74a51.893,51.893,0,0,1,.3-41.052l40.533,22.672-37.117-29.131A51.8,51.8,0,1,1,936.7,330.069a51.8,51.8,0,0,1,5.609,9.628l-37.469,17.992,39.725-11.963a51.814,51.814,0,0,1-9.88,48.351,51.8,51.8,0,1,1-81.381-2.566,51.814,51.814,0,0,1,2.015-64.013Z"
                    transform="translate(-841.186 -244.965)"
                    fill="#52429a"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                  />
                  <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M946.792,468.069a51.6,51.6,0,0,1-12.068,31.66,51.8,51.8,0,1,1-81.381-2.566C846.659,488.133,946.976,462.26,946.792,468.069Z"
                    transform="translate(-841.205 -350.607)"
                    stroke="rgba(82,66,154,0.2)"
                    strokeWidth={1}
                    opacity="0.1"
                  />
                </g>
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M157.82,370.94l5.5-.016h7.76L180.9,211.531,278.065,49.384l-4.224-4.533V33.37l-105.087,174.4Z"
                  transform="translate(-75.022 -15.861)"
                  fill="#f1c0c0"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M169.43,381.324H176.6l9.812-159.393L283.583,59.783,279.36,55.25,179.132,219.5Z"
                  transform="translate(-80.54 -26.261)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_14"
                  data-name="Path 14"
                  d="M126.91,669.165l251.777,19.267.215.016,243.665-14.985.184-.011V663.162l-268.488-4.927-224-.215h-1.637l-.178,1.154Z"
                  transform="translate(-60.33 -312.758)"
                  fill="#f1c0c0"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_15"
                  data-name="Path 15"
                  d="M126.91,669.165l251.777,19.267.215.016,243.665-14.985.184-.2v-9.885h-.215l-243.848,8.143-248.424-13.5h-.037l-.441.289-1.338.866Z"
                  transform="translate(-60.33 -312.758)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_16"
                  data-name="Path 16"
                  d="M126.91,669.426l251.777,19.267V671.782l-248.9-13.212-1.338.866Z"
                  transform="translate(-60.33 -313.02)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M378.88,44.745l111,119.138-3.432,209.565,9.429,1.139.157.021h9.429l1.128-201.726L714.44,242.309l3.5,123.619,7.587.85,2.571.289-5.95-133.331L504.876,157.455,385.738,33.6H378.88Z"
                  transform="translate(-180.092 -15.97)"
                  fill="#f1c0c0"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_18"
                  data-name="Path 18"
                  d="M620.65,291.7l.855,3.857,207.849,69.428L832.859,488.6l7.587.85-5.95-127.04Z"
                  transform="translate(-295.005 -138.646)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_19"
                  data-name="Path 19"
                  d="M378.88,44.745l111,119.138-3.432,209.565,9.429,1.139,2.571-217.561L378.88,33.6Z"
                  transform="translate(-180.092 -15.97)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_20"
                  data-name="Path 20"
                  d="M621.42,439.661l76.234,15.012.026.005,133.52,26.3,6.113-2.45-.021-.43-.4-8.526L621.5,426.05Z"
                  transform="translate(-295.371 -202.502)"
                  fill="#f1c0c0"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_21"
                  data-name="Path 21"
                  d="M766.76,480.61l133.52,26.3,6.113-2.45-.021-.43Z"
                  transform="translate(-364.452 -228.435)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_22"
                  data-name="Path 22"
                  d="M776.49,350.56l2.062,113.513,1.065,58.236,9.387-.315,5.908-.2L793.076,352.2,789,350.849l-.892-.289Z"
                  transform="translate(-369.077 -166.622)"
                  fill="#f1c0c0"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_23"
                  data-name="Path 23"
                  d="M776.65,350.51v.026l1.978,113.513,1.065,58.236,9.387-.315V350.51Z"
                  transform="translate(-369.152 -166.598)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_24"
                  data-name="Path 24"
                  d="M493.333,487.024a11.956,11.956,0,0,1,1.574,1.023,10.414,10.414,0,0,1,1.574,1.726c2.251,2.912,4.329,6.3,4.108,9.969a4.056,4.056,0,0,1-1.17,2.886,5.244,5.244,0,0,1-3.479.829,7.407,7.407,0,0,1-3.857-.682c-1.144-.682-2.1-2.01-3.452-1.978a1.77,1.77,0,0,1-.577,0c-.467-.152-.561-.766-.866-1.154-.525-.7-1.632-.525-2.456-.22s-1.737.761-2.55.409a2.649,2.649,0,0,1-1.107-1.107c-1.947-3.148-2.361-6.931-2.728-10.588-.226-2.225-1.947-9.812,2.8-8.086,2.1.756,4.061,2.267,5.971,3.374Z"
                  transform="translate(-232.956 -274.096)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_25"
                  data-name="Path 25"
                  d="M497.535,492.411a2.34,2.34,0,0,0,2.881-.115,4.339,4.339,0,0,0,1.4-2.718c.525-.163.792.525,1.128.944.588.714,1.784.7,2.319,1.464.373.525.289,1.254.551,1.847.341.766,1.186,1.165,1.763,1.784a6.075,6.075,0,0,1,1.154,2.3l.861,2.582a12.759,12.759,0,0,1,.787,3.342,4.329,4.329,0,0,1-1,3.2c-1.154,1.244-3.049,1.375-4.722,1.338a6.075,6.075,0,0,1-1.658-.194,4.706,4.706,0,0,1-2.828-3.463,43.725,43.725,0,0,1-.582-4.628,18.139,18.139,0,0,0-1.312-4.4c-.462-1.091-1.732-2.718-1.711-3.878C496.948,491.818,497.22,492.165,497.535,492.411Z"
                  transform="translate(-241.849 -278.733)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_26"
                  data-name="Path 26"
                  d="M495.516,478.743a8.661,8.661,0,0,1-.425-2.3,10.027,10.027,0,0,1,1.443-4.46l-6,.813a2.655,2.655,0,0,0-1.941.85,2.1,2.1,0,0,0,0,1.936,9.888,9.888,0,0,1,.714,1.873,9.359,9.359,0,0,0,.194,1.684,3.568,3.568,0,0,0,.771,1.086,36.378,36.378,0,0,1,4.282,6.359c-.037-.063,3.615-2.891,3.468-3.815-.084-.525-1.139-1.154-1.474-1.658A8.441,8.441,0,0,1,495.516,478.743Z"
                  transform="translate(-237.946 -270.381)"
                  fill="#be6f72"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_27"
                  data-name="Path 27"
                  d="M490.233,358.04v5.168l-88.5,17.263-4.591,2.781H381.3V380.34l86.953-21.009Z"
                  transform="translate(-181.242 -170.177)"
                  fill="#f1c0c0"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_28"
                  data-name="Path 28"
                  d="M490.233,367.89l-88.5,17.263-4.591,2.781H381.3l87.6-18.747Z"
                  transform="translate(-181.242 -174.859)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_29"
                  data-name="Path 29"
                  d="M451.228,723.163a6.858,6.858,0,0,0-8.343-1.774,2.2,2.2,0,0,0-.766.6c-.525.735-.189,1.747-.142,2.655.121,2.214-1.642,4.014-3.227,5.562a7.628,7.628,0,0,0-2.1,2.844,2.665,2.665,0,0,0,.929,3.148,3.869,3.869,0,0,0,1.438.4,15.508,15.508,0,0,0,5.09.142,5.514,5.514,0,0,0,4.04-2.812,2.966,2.966,0,0,1,.677-1.118c.923-.729,2.34.126,3.39-.393.866-.43.9-1.107.913-2C453.159,727.948,452.792,725.157,451.228,723.163Z"
                  transform="translate(-213.292 -388.584)"
                  fill="#52429a"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_30"
                  data-name="Path 30"
                  d="M478.29,719.562a17.275,17.275,0,0,1,.819,5.368,5.179,5.179,0,0,1-.488,3.059,4.18,4.18,0,0,1-2.734,1.574c-2.188.451-4.722.026-6.134-1.711a6.472,6.472,0,0,1-1.107-4.869c.168-1.411.525-3.064-.488-4.066-.262-.268-.6-.457-.845-.745a2.5,2.5,0,0,1-.157-2.393,10.4,10.4,0,0,0,.824-2.366c.042-.388,7.1.273,7.755.593.887.435.75,1.165,1.018,2.046C477.126,717.279,477.839,718.387,478.29,719.562Z"
                  transform="translate(-227.762 -385.077)"
                  fill="#52429a"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_31"
                  data-name="Path 31"
                  d="M460.2,580.111c1.385.9,1.92,2.66,2.136,4.3.593,4.486-.446,9.02-.525,13.548-.073,6.344,1.763,12.8.194,18.947-.939,3.673-.142,7.87-1.023,11.58-.262,1.1-.745,2.141-1,3.243a14.148,14.148,0,0,0,.766,7.22,7.46,7.46,0,0,1,.446,1.957,7.042,7.042,0,0,1-.766,2.959l-3.148,7.445c-.352.834-1.737.971-2.623,1.081-1.669.2-3.531.341-4.859-.693s-1.648-2.765-1.852-4.381a67.158,67.158,0,0,1-.525-9.355,7.71,7.71,0,0,0-.215-2.429,21.29,21.29,0,0,1-1.1-2.623c-.22-1.228.4-2.435.635-3.673a11.065,11.065,0,0,0-.052-3.405c-.2-1.679-.441-3.358-.708-5.027-.378-2.335.163-4.638.525-6.978a19.241,19.241,0,0,0-.525-6.622,18.255,18.255,0,0,1-.656,5.247c-.278.834-.677,1.632-.918,2.482-1.076,3.815,1.217,7.818.892,11.769-.152,1.847-.876,3.673-.672,5.494a18.531,18.531,0,0,0,1.186,3.825,4.959,4.959,0,0,1,0,3.909c-1.705,3.222-.43,7.6,1.1,10.909a14.717,14.717,0,0,1,.808,1.815c.451,1.49.073,3.09.194,4.644a2.928,2.928,0,0,1-2.461-.74c-.231-.241-.42-.525-.645-.776a6.408,6.408,0,0,0-2.193-1.37,2.881,2.881,0,0,0-1.574-.362,3.149,3.149,0,0,0-1.5.929,14.663,14.663,0,0,1-1.648,1.254,1.951,1.951,0,0,1-.839.373.74.74,0,0,1-.771-.394.933.933,0,0,1-.058-.273,41.526,41.526,0,0,1-.31-4.775c0-2.744-3.285-4.633-3.7-7.346-.331-2.188.283-4.418.079-6.622a32.223,32.223,0,0,1-.394-3.379c0-.735.168-1.453.226-2.183a16.327,16.327,0,0,0-.037-2.429l-.163-2.534a21.9,21.9,0,0,0-1.317-7.346,24.961,24.961,0,0,1-2.046-8.437c-.1-1.836-.037-3.673-.247-5.515a27.148,27.148,0,0,1-.488-4.985c.1-1.291.525-2.54.624-3.83.2-2.482-.74-4.9-1.48-7.272s-1.286-5.011-.315-7.3a2.4,2.4,0,0,1,.672-.976,2.928,2.928,0,0,1,1.238-.462,96.082,96.082,0,0,1,27.4-1.747,9.1,9.1,0,0,1,4.224,1.317Z"
                  transform="translate(-208.376 -321.004)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <circle
                  id="Ellipse_13"
                  data-name="Ellipse 13"
                  cx="8.406"
                  cy="8.406"
                  r="8.406"
                  transform="translate(213.632 186.567)"
                  fill="#be6f72"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_32"
                  data-name="Path 32"
                  d="M428.243,471.9a3,3,0,0,1,0,1.464,3.314,3.314,0,0,1-.551.923A23.713,23.713,0,0,1,425,477.213a4.874,4.874,0,0,0,2.513,2.482,14.592,14.592,0,0,0,3.468.992,3.635,3.635,0,0,0,3.4-.588l4.67-2.8a9.329,9.329,0,0,0,1.941-1.4,4.78,4.78,0,0,0,1.354-3.285.9.9,0,0,0-.168-.619,1.1,1.1,0,0,0-.64-.268,5.69,5.69,0,0,1-3.673-3.206,16.981,16.981,0,0,1-1.275-4.864l-4.979,2.624c-.74.394-1.474.787-2.24,1.128-.488.22-1.474.4-1.821.85C426.889,469.085,428.069,470.906,428.243,471.9Z"
                  transform="translate(-207.832 -266.426)"
                  fill="#be6f72"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_33"
                  data-name="Path 33"
                  d="M423.478,481.729a5.535,5.535,0,0,0-1.611,2.177,5.674,5.674,0,0,0,.294,3.2,95.334,95.334,0,0,1,3.148,13.532c.441,3.148.6,6.344.819,9.529.441,6.5,1.081,16.853,1.936,23.307,3.148.142,6.218-.777,9.34-1.112,5.835-.619,11.842.8,17.556-.525-1.385-5.473-2.77-14.817-4.156-20.285a38.707,38.707,0,0,1-1.27-6.585c-.121-1.6-.047-3.206-.026-4.817.047-3.148-.126-6.3-.3-9.445a59.913,59.913,0,0,0-1.27-10.94,2.035,2.035,0,0,0-.609-1.2,2.464,2.464,0,0,0-1.831-.163,7.965,7.965,0,0,1-5.446-1.291c-.693-.472-1.621-1.049-2.267-.525a2.256,2.256,0,0,0-.525,1.118,5.588,5.588,0,0,1-3.285,3.237,16.437,16.437,0,0,1-4.649.955,2.283,2.283,0,0,1-1.443-.163c-.745-.456-.8-2.1-1.737-2.209C425.325,479.425,424.034,481.2,423.478,481.729Z"
                  transform="translate(-206.278 -272.469)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_34"
                  data-name="Path 34"
                  d="M427.457,494.857c-1.936-1.852-2.786-4.539-4.2-6.821a15.184,15.184,0,0,0-3.626-3.988,10.812,10.812,0,0,1-1.973-1.674c-.5-.614-.876-1.432-1.632-1.669a1.973,1.973,0,0,0-1.768.488,17.4,17.4,0,0,0-1.312,1.4c-2.225,2.3-6.134,2.623-7.9,5.289a4.334,4.334,0,0,0-.939,1.968,15.248,15.248,0,0,0,2.8,10.966,3.726,3.726,0,0,0,1.941,1.574,6.076,6.076,0,0,0,.378,2.886,77.16,77.16,0,0,0,3.573,9.733,23.545,23.545,0,0,0-.7,3.773c-.367,3.206-.026,6.459-.373,9.67-.283,2.623-1.049,5.179-1.076,7.808,0,.42.037.918.4,1.133a1.206,1.206,0,0,0,.624.131l6.454.194a52.388,52.388,0,0,0,11.218-.472,4.673,4.673,0,0,0,1.411-.446c1.249-.7,1.663-2.272,1.863-3.673a32,32,0,0,0,.31-5.488c.782,2.471,1.711,5.027,4.072,6.1a9.136,9.136,0,0,0,4.045.488,76.167,76.167,0,0,0,8.81-.908,1.16,1.16,0,0,0,1.285-1.349l.031-2.865c.063-5.819-1.38-11.381-1.941-17.173a37.337,37.337,0,0,0-.609-5.462c-.184-.75-.451-1.485-.614-2.24a16.015,16.015,0,0,1-.262-2.24l-.409-5.772c-.194-2.671-.472-5.247-.677-7.912a38.3,38.3,0,0,0-1.123-7.692c-.456-1.574-1.406-3.358-3.048-3.552a6.283,6.283,0,0,0-2.561.551,10.347,10.347,0,0,1-6.3-.026,8.864,8.864,0,0,0-1.962-.525,1.926,1.926,0,0,0-1.794.745,2.692,2.692,0,0,0-.278,1.322A69.986,69.986,0,0,1,427.457,494.857Z"
                  transform="translate(-197.843 -272.784)"
                  fill="#52429a"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_35"
                  data-name="Path 35"
                  d="M419.438,504.313c-2.419-2.55-4.9-5.147-8.017-6.769a6.4,6.4,0,0,0-3.982-.881,2.982,2.982,0,0,0-2.56,2.8,18.121,18.121,0,0,0,.724,2.45c.189.944-.084,1.952.21,2.865a4.849,4.849,0,0,0,1.049,1.611l3.715,4.4a23.915,23.915,0,0,0,5.174,4.969,7.777,7.777,0,0,0,6.874.96,8.448,8.448,0,0,0,3.767-3.458c.923-1.469,1.574-3.075,2.44-4.591a22.8,22.8,0,0,1,5.247-6.365,5.829,5.829,0,0,1-3.148-1.574,5.2,5.2,0,0,1-.5-.9l-.85-1.836a2.1,2.1,0,0,0-1.574.593,13.194,13.194,0,0,1-1.17,1.191c-.74.556-1.742.708-2.414,1.343a6.392,6.392,0,0,0-.7.882A5.887,5.887,0,0,1,419.438,504.313Z"
                  transform="translate(-198.266 -282.082)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_36"
                  data-name="Path 36"
                  d="M455.841,476.878c1.821-3.321,1.737-7.3,2.256-11.055a5.047,5.047,0,0,1,1-2.744c1.049-1.186,2.9-1.2,4.486-1.049.467.052,1.049.273,1.023.74a.944.944,0,0,1-.236.446,12.483,12.483,0,0,0-2.592,6.884c.824.572,2.1-.6,2.891,0,.525.441.283,1.312-.031,1.941q-1.1,2.188-2.261,4.345a13.952,13.952,0,0,1-2.4,3.458c-.666.64-1.448,1.144-2.125,1.773-1.574,1.474-2.524,3.557-4.15,5a.85.85,0,0,1-.525.268.882.882,0,0,1-.551-.247,7.955,7.955,0,0,1-1.983-2.4c-.619-1.144-.525-1.48.451-2.288A17.344,17.344,0,0,0,455.841,476.878Z"
                  transform="translate(-219.836 -265.619)"
                  fill="#be6f72"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_37"
                  data-name="Path 37"
                  d="M417.916,500.644c.315.194.7.414,1.049.252a1.091,1.091,0,0,0,.352-.341,12.348,12.348,0,0,0,1.49-2.592,1,1,0,0,0,.11-.42c0-.336-.3-.582-.577-.777a21.386,21.386,0,0,0-4.77-2.267,9.841,9.841,0,0,0-4.3-.85,4.1,4.1,0,0,0-2.87,1.459c-1.049,1.348.708,1.758,1.81,2.246C412.759,498.513,415.518,499.185,417.916,500.644Z"
                  transform="translate(-199.788 -280.669)"
                  fill="#6c63ff"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_38"
                  data-name="Path 38"
                  d="M423.672,519.688a.771.771,0,0,0,.22.661c.152-.745-.047-1.532.11-2.282.231-1.128,1.327-1.978,1.422-3.111C423.415,514.561,423.688,518.47,423.672,519.688Z"
                  transform="translate(-207.197 -290.794)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_39"
                  data-name="Path 39"
                  d="M569,358.04v5.168l-21.334,1.3-.645-5.174Z"
                  transform="translate(-260.009 -170.177)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.2"
                />
                <path
                  id="Path_40"
                  data-name="Path 40"
                  d="M417.538,450.484c1.333-1.086.561-3.363,1.464-4.822a4.685,4.685,0,0,1,2.282-1.574,10.384,10.384,0,0,1,3.332-.924,3.867,3.867,0,0,1,3.148,1.16c.341.388.572.861.892,1.265a3.411,3.411,0,0,0,3.306,1.144c.7-.157,1.422-.687,1.375-1.4a1.978,1.978,0,0,0-.63-1.123l-1.5-1.663c-1.705-1.889-3.6-3.893-6.1-4.365a10.468,10.468,0,0,0-5.2.7c-.677.226-1.438.561-1.627,1.249-.126.472.063.986-.047,1.464-.215.95-1.432,1.27-2,2.067s-.394,1.742-.556,2.624a22.951,22.951,0,0,0-.693,2.655c-.037.551.241,1.574.861,1.773S417.155,449.829,417.538,450.484Z"
                  transform="translate(-203.066 -254.263)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_41"
                  data-name="Path 41"
                  d="M432.423,440.674a15.741,15.741,0,0,0-2.791-6.38,11.181,11.181,0,0,0-4.969-3.946,7.115,7.115,0,0,0-6.186.488,8.983,8.983,0,0,0-3.09,3.9c-1.359,2.928-1.863,6.506-.283,9.319.63-.766,1.711-.42,2.665-.7a27.788,27.788,0,0,0,3.348-1.637C424.552,440.2,428.75,441.43,432.423,440.674Z"
                  transform="translate(-202.662 -250.361)"
                  fill="#fed253"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_42"
                  data-name="Path 42"
                  d="M417.387,447.588a3.206,3.206,0,0,1,.472-2.713.341.341,0,0,1,.278-.126.362.362,0,0,1,.215.189,11.74,11.74,0,0,1,.986,1.931,2,2,0,0,0-2.1.813"
                  transform="translate(-204.143 -257.438)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_43"
                  data-name="Path 43"
                  d="M440.667,442.717l-.189-1.873a.855.855,0,0,1,.037-.462.593.593,0,0,1,.766-.21,1.574,1.574,0,0,1,.614.614,11.018,11.018,0,0,1,1.081,2.136,6.348,6.348,0,0,0-2.555.031"
                  transform="translate(-215.161 -255.232)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_44"
                  data-name="Path 44"
                  d="M418.25,502.21v4.282l-3.615.241H395.62V502.21Z"
                  transform="translate(-188.048 -238.701)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_45"
                  data-name="Path 45"
                  d="M363.79,434.865v4.523H341.16l-60.12-75.31V360.52h12.6Z"
                  transform="translate(-133.588 -171.356)"
                  fill="#f1c0c0"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_46"
                  data-name="Path 46"
                  d="M363.79,434.865v4.523H341.16l-60.12-75.31V360.52h12.6Z"
                  transform="translate(-133.588 -171.356)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_47"
                  data-name="Path 47"
                  d="M363.79,434.865v4.523H341.16l-60.12-75.31V360.52l60.445,74.345Z"
                  transform="translate(-133.588 -171.356)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_48"
                  data-name="Path 48"
                  d="M301.472,730.614a1.574,1.574,0,0,1-1.375,1.852,9.351,9.351,0,0,0-4.04,2.1c-1.034,1.118-1.238,3.19,0,4.1a3.982,3.982,0,0,0,2.1.572,14.221,14.221,0,0,0,7.01-.876c1.543-.714,3-1.931,4.691-1.821.876.052,1.81.462,2.592.063s1-1.511,1.007-2.44a18.065,18.065,0,0,0-.866-5.714c-.079-.252-3.416-.446-3.815-.525l-4.045-.525c-.766-.1-2.419-.677-3.022-.037S301.472,729.853,301.472,730.614Z"
                  transform="translate(-146.139 -391.622)"
                  fill="#52429a"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_49"
                  data-name="Path 49"
                  d="M353.033,701.812a12.673,12.673,0,0,0,.829,2.749c.561,1.427,1.28,2.944,2.655,3.636a4.739,4.739,0,0,0,4.051-.194,3.336,3.336,0,0,0,1.349-1.023,4.061,4.061,0,0,0,.525-2.356,12.871,12.871,0,0,0-1.049-5.934c-.8-1.574-2.188-2.928-2.209-4.67l-4.78.923a1.363,1.363,0,0,0-.7.278,1.211,1.211,0,0,0-.3.572A15.62,15.62,0,0,0,353.033,701.812Z"
                  transform="translate(-173.559 -375.916)"
                  fill="#52429a"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_50"
                  data-name="Path 50"
                  d="M244.289,606.02a7.811,7.811,0,0,0,.766,4.958,3.837,3.837,0,0,0,4.344,1.842.634.634,0,0,0,.394-.3.739.739,0,0,0-.068-.525,7.744,7.744,0,0,1,.163-5.835c.1-.241.331-.525.577-.43a.525.525,0,0,1,.236.241,2.744,2.744,0,0,1,.367,1.448,5.384,5.384,0,0,0-.042,1.391c.1.451.582.876,1,.682a1.05,1.05,0,0,0,.477-.677c1.17-3.384.64-7.083.1-10.625a.556.556,0,0,0-.624-.582c-2.477-.247-3.83-.839-5.247,1.464A14.383,14.383,0,0,0,244.289,606.02Z"
                  transform="translate(-121.897 -329.971)"
                  fill="#52429a"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_51"
                  data-name="Path 51"
                  d="M298.172,596.1a32.175,32.175,0,0,0-1.081,15.122l.551,4.544c.189,1.532.372,3.059.64,4.575a12.149,12.149,0,0,1,.278,2.377,12.732,12.732,0,0,1-.373,2.335,27.28,27.28,0,0,0-.551,4.88c-.058,2.624.268,5.247.472,7.87a87.652,87.652,0,0,1-.184,15.7,5.887,5.887,0,0,0,.861,4.045,5.208,5.208,0,0,1,.761,1.249c.394,1.2-.525,2.4-.761,3.636a3.673,3.673,0,0,0,3.054,4.2c4.2.5,8.511.273,12.294,2.193.4-1.165-.472-2.487-.073-3.673.252-.735.944-1.212,1.417-1.831a5.331,5.331,0,0,0,.9-3.2,11.694,11.694,0,0,0-.777-4.339,9.387,9.387,0,0,1-1.049-3.531,4.462,4.462,0,0,0-.031-1.81,2.829,2.829,0,0,0-.677-.845,10.667,10.667,0,0,1-2.744-6.218,28.634,28.634,0,0,1,.22-6.895c.257-2.172.6-4.465,1.983-6.16a39.525,39.525,0,0,1,1.107-15.347c.136-.462.352-1,.824-1.107a1.175,1.175,0,0,1,1.007.4,6.877,6.877,0,0,1,1.574,2.959,6.452,6.452,0,0,1,.493,3.584c-.126.525-.378.986-.525,1.49a4.418,4.418,0,0,0,.157,3.08,2.96,2.96,0,0,1,.378,1.16,3.212,3.212,0,0,1-.315,1.007,4.638,4.638,0,0,0,.435,3.752,13.584,13.584,0,0,0,2.45,3.007,11.019,11.019,0,0,0,.341,6.065.766.766,0,0,1,.068.583c-.094.2-.336.273-.525.414-.525.43-.2,1.244.152,1.8a41.388,41.388,0,0,0,3.185,4.418c1.049,1.254.955,3.673,2.519,4.124a4.724,4.724,0,0,0,1.994,0c1.543-.236,3.264-.682,4.019-2.046a5.5,5.5,0,0,1,.918-1.663c.483-.42,1.107-.493,1.375-1s-.032-1.165.058-1.747.6-1.049.761-1.663c.388-1.417-1.265-2.582-1.49-4.03-.325-2.1,2.319-3.673,2.209-5.772-.231-4.56-.378-9.14-.614-13.7a98.8,98.8,0,0,1-.126-12.273c.184-2.545.525-5.21-.409-7.577-1.343-3.337-5.048-5.21-8.631-5.567s-7.157.493-10.709,1.049A67.688,67.688,0,0,1,298.172,596.1Z"
                  transform="translate(-146.827 -328.657)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <circle
                  id="Ellipse_14"
                  data-name="Ellipse 14"
                  cx="8.406"
                  cy="8.406"
                  r="8.406"
                  transform="translate(153.591 200.477)"
                  fill="#fbbebe"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_52"
                  data-name="Path 52"
                  d="M310.162,500.079a3.584,3.584,0,0,1-3.426,2.167A4.225,4.225,0,0,0,308,505.767a14.943,14.943,0,0,0,14.3,4.906,7.059,7.059,0,0,0,2.818-1.175,6.25,6.25,0,0,0,2.151-3.725,18.524,18.524,0,0,0,.2-4.381,1.133,1.133,0,0,0-.231-.808,1.155,1.155,0,0,0-.735-.241,12.737,12.737,0,0,1-5.184-1.1c-1.558-.871-2.665-2.839-1.915-4.455-.121.252-3.185.373-3.589.425-1.265.178-2.529.378-3.788.609a6.884,6.884,0,0,0-1.779.336c-.761.393-.477.2-.3.913C310.22,498.164,310.614,498.946,310.162,500.079Z"
                  transform="translate(-151.587 -281.222)"
                  fill="#fbbebe"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_53"
                  data-name="Path 53"
                  d="M288.86,509.068a13.92,13.92,0,0,1-3.363-.373,4.722,4.722,0,0,1-2.76-1.842c-.388-.588-.64-1.327-1.259-1.658-1.013-.525-2.167.362-2.975,1.175a10.809,10.809,0,0,1-2.529,2.036c-1.123.593-2.435.8-3.494,1.5a8.784,8.784,0,0,0-2.1,2.267L262.945,522.3c-2.986,4.072-5.583,8.442-8.243,12.74-2.3,3.72-3.51,8-5.247,12.016a1.343,1.343,0,0,0-.163.808c.063.273.394.493.624.336-.782.777-.094,2.1-.278,3.19a3.915,3.915,0,0,1-1.249,1.957,9.866,9.866,0,0,1,3.463.163,10.615,10.615,0,0,1,3.274,1.574c.635-.1.577-1.228,1.049-1.648.283-.247.7-.215,1.076-.289,1.4-.273,1.957-1.957,3.033-2.907.9-.792,2.167-1.049,3.117-1.794,1.543-1.212,1.873-3.369,2.681-5.158.687-1.516,1.768-2.839,2.372-4.392a18.915,18.915,0,0,1,1.144-3.028c.9-1.5,2.587-2.3,4.2-3.017a6.951,6.951,0,0,1,3.2-.855c-.058,2.44-.367,4.843.163,7.225.184.839.441,1.658.661,2.492a46.93,46.93,0,0,1,1.285,11.543,35.116,35.116,0,0,1,7.346-.881c1.947-.058,3.888.194,5.835.157,2.309-.042,4.591-.488,6.9-.645a12.888,12.888,0,0,1,6.763,1.049,64.247,64.247,0,0,1,.278-9.969l.556-5.215a32.038,32.038,0,0,1,.7-4.5c.3-1.2.745-2.351,1.081-3.542,1.181-4.2.965-8.678.74-13.049a16.448,16.448,0,0,0-2-6.454,17.46,17.46,0,0,0-1.259-2.141,12.4,12.4,0,0,0-10.84-5.09,2.194,2.194,0,0,0-.777.168,2.587,2.587,0,0,0-.992,1.181,12.855,12.855,0,0,1-4.57,4.743Z"
                  transform="translate(-123.889 -285.101)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_54"
                  data-name="Path 54"
                  d="M303.429,479.458c.236-.525.871-.719,1.259-1.139.745-.8.409-2.073.525-3.148a4.522,4.522,0,0,1,2.991-3.453,9.666,9.666,0,0,1,4.722-.3,4.57,4.57,0,0,1,2.13.708c.273.2.525.456.782.64a2.1,2.1,0,0,0,2.854-.666c-1.857-2.235-3.914-4.6-6.737-5.284a13.821,13.821,0,0,0-2.944-.278,9.559,9.559,0,0,0-3.862.451,6.437,6.437,0,0,0-3.389,3.914,19.03,19.03,0,0,0-.824,5.247,19.766,19.766,0,0,0,0,3.568,9.864,9.864,0,0,0,1.752,4.5,1.359,1.359,0,0,0,.525.488C305.607,485.754,303.235,479.894,303.429,479.458Z"
                  transform="translate(-148.826 -267.79)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_55"
                  data-name="Path 55"
                  d="M316.836,465.923c-.289-2.471-2.052-4.512-3.925-6.155a14.472,14.472,0,0,0-5.273-3.174,7.046,7.046,0,0,0-5.95.724,9.142,9.142,0,0,0-2.9,3.982,12.536,12.536,0,0,0-1.264,5.772,6.223,6.223,0,0,0,2.818,5,5.3,5.3,0,0,1,2.728-1.758A133.6,133.6,0,0,1,316.836,465.923Z"
                  transform="translate(-147.242 -262.907)"
                  fill="#fed253"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_56"
                  data-name="Path 56"
                  d="M303.483,472.72c.168,0,.278.173.362.315a13.3,13.3,0,0,1,1.1,2.1c-.614.131-1.669.278-1.973-.262C302.806,474.6,303,472.694,303.483,472.72Z"
                  transform="translate(-149.803 -270.732)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_57"
                  data-name="Path 57"
                  d="M326.542,468.113c-.126.121-.273-.126-.273-.3v-2.036a.3.3,0,0,1,.037-.163.247.247,0,0,1,.173-.084c.425-.047.777.315,1.049.661a11.08,11.08,0,0,1,1.076,1.789l-2.219-.068"
                  transform="translate(-160.905 -267.311)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_58"
                  data-name="Path 58"
                  d="M364.353,522.492a13.719,13.719,0,0,1,1.543-1.264,23.274,23.274,0,0,1,4.843-1.973,6.39,6.39,0,0,0,3.925-3.248,7.714,7.714,0,0,0,.3-3.148,3.148,3.148,0,0,0-.231-1.3,2.576,2.576,0,0,0-.829-.9c-2.214-1.637-5.184-1.768-7.933-1.6a49.725,49.725,0,0,0-17.53,4.376,1.521,1.521,0,0,0-.735.525,1.5,1.5,0,0,0-.142.729,12.067,12.067,0,0,0,.593,4.57c.724,1.868,2.214,3.374,2.839,5.278.283.855.378,1.763.624,2.624a3.673,3.673,0,0,0,1.474,2.193c2.073,1.238,4.03-.425,5.467-1.716Z"
                  transform="translate(-171.017 -287.979)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_59"
                  data-name="Path 59"
                  d="M310.818,525.87l-2.66-5.8a20.307,20.307,0,0,1-1.007-2.482c-.3-1.013-.451-2.062-.735-3.08-.934-3.39-3.29-6.212-4.439-9.534a1.81,1.81,0,0,0-.43-.8,1.4,1.4,0,0,0-1.17-.21c-1.606.278-2.86,1.5-4.329,2.193-.682.315-1.417.525-2.1.887a2.624,2.624,0,0,0-1.406,1.674,4.092,4.092,0,0,0,.572,2.356,26.606,26.606,0,0,1,1.815,10.347c.047,2.372-.073,4.916-1.474,6.821-2.692,3.673-.971,9.067.037,13.511.121.525.262,1.091.346,1.648a15.149,15.149,0,0,1,.121,2.1,16.426,16.426,0,0,1-1.118,6.921,7.744,7.744,0,0,0,3.148.892q4.57.582,9.177.818a10,10,0,0,0,2.881-.147,5.247,5.247,0,0,0,3.878-5.142,6.487,6.487,0,0,0,1.532,4.04,6.1,6.1,0,0,0,4.024,1.238,74.821,74.821,0,0,0,12.121-.341,2.1,2.1,0,0,0,.745-.173c.777-.388.819-1.459.756-2.319-.115-1.611-.236-3.222-.43-4.822a19.731,19.731,0,0,1-.252-3.085,17.749,17.749,0,0,1,.525-3.148,35.7,35.7,0,0,0,1.023-9.969,16.828,16.828,0,0,1-.1-2.461c.136-1.852,1.112-3.615.929-5.457-.525-5.415-.95-10.971-2.461-16.2a4.2,4.2,0,0,0-1.432-2.471c-1.049-.7-2.524-.336-3.725-.782a9.316,9.316,0,0,1-1.6-.95,7.346,7.346,0,0,0-3.615-1.112,3.069,3.069,0,0,0-2.624.955,3.809,3.809,0,0,0-.525,1.432c-.761,3.2-1.653,6.365-2.545,9.528l-.855,3.033-2.293,8.143C310.9,524.784,311.049,525.052,310.818,525.87Z"
                  transform="translate(-144.624 -284.089)"
                  fill="#52429a"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_60"
                  data-name="Path 60"
                  d="M333.257,400.25l50.754,53.336v4.523H361.38L323.24,408.33"
                  transform="translate(-153.646 -190.24)"
                  fill="#f1c0c0"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_61"
                  data-name="Path 61"
                  d="M333.257,400.25l50.754,53.336v4.523H361.38L323.24,408.33"
                  transform="translate(-153.646 -190.24)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_62"
                  data-name="Path 62"
                  d="M324.048,414.31l.163.058,37.495,45.9h22.3v4.523H361.38l-38.14-49.778Z"
                  transform="translate(-153.646 -196.922)"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                  opacity="0.1"
                />
                <path
                  id="Path_63"
                  data-name="Path 63"
                  d="M342.895,502.224c-1.836.8-3.878,1.831-4.428,3.762a1.884,1.884,0,0,0,1.857,2.524,6.3,6.3,0,0,0,2.524-.462l10.835-3.578c.294-.094.63-.236.7-.525a.9.9,0,0,0-.1-.525c-.336-.819-.666-2.492-1.37-3.064-.577-.462-1.721-.3-2.419-.289C347.806,500.088,345.282,501.174,342.895,502.224Z"
                  transform="translate(-166.653 -283.713)"
                  fill="#6c63ff"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
                <path
                  id="Path_64"
                  data-name="Path 64"
                  d="M363.314,503.9a17.426,17.426,0,0,1,5.378.834,9.58,9.58,0,0,1,4.455,3.043,3.336,3.336,0,0,1,.7,1.375c.1.525,1.815.84,1.438,1.2,1.149-.184.876.357,2.041.346a3.857,3.857,0,0,0,3.122-1.238,4.056,4.056,0,0,0,.614-2.566,4.371,4.371,0,0,0-.346-1.815,5.36,5.36,0,0,0-2.844-2.2l-9.371-4.287a6.223,6.223,0,0,0-1.732-.614,6.476,6.476,0,0,0-1.527.037L361,498.5a6.365,6.365,0,0,1,2.9,5.6"
                  transform="translate(-177.412 -282.722)"
                  fill="#3f3d56"
                  stroke="rgba(82,66,154,0.2)"
                  strokeWidth={1}
                />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};
